export default {"src":"/_next/static/media/mileprogram-benefit-03.e1872195.svg","height":150,"width":300,"blurWidth":0,"blurHeight":0};